import React from 'react';
import styled from 'styled-components';
import ICellProps from '../ICellProps';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import Readonly from '../Readonly';


interface IProps extends ICellProps {
  onChange: (value: string) => void;
  list: { key: any; value: any }[];
}

const List: React.FC<IProps> = (props: IProps) => {
  return props.readonly ? (
    <Readonly>{((props.list || []).find((el) => el.key === props.value) || { value: '' }).value}</Readonly>
  ) : (
    <Dropdown
      options={(props.list || []).map((el) => ({
        key: el.key,
        text: el.value,
      }))}
      styles={{
        title: {
          border: 'none',
          textAlign: 'left',
        },
      }}
      selectedKey={props.value}
      onChange={(
        event: React.FormEvent<HTMLDivElement>,
        item?: IDropdownOption,
        index?: number | undefined
      ) => {
        event.eventPhase === 3 &&
          props.onChange &&
          props.onChange(item!.key as string);
      }}
    />
  );
};

export default List;
